import React, { useState, useEffect } from 'react'
import { Drawer, Form, Button, notification, Card, Row, Col, Input, Tooltip, Icon } from 'antd'
import { useDispatch } from 'react-redux'
import { getSingleContractFxn, updateContract } from '../actions/contract'
import {
  countryIds,
  InputBox,
  ProgramLevel,
  Intakes,
  countryCurrencyObject,
  DownloadLink
} from '../../../components/_utils/appUtils'
import { listAllCountries } from '../../countries/actions/countries'
import { listQuickSearchUniversities } from '../../university/actions/university'
import moment from 'moment'
import GetEachFormFields from '../../../components/_utils/appFormUtils'
// import AgentTypeheadComponent from '../../../components/_utils/AgentTypeheadComponent'

const instituteType = [
  'School',
  'College',
  'University',
  'Pathways'
]

const Edit = (props) => {
  const dispatch = useDispatch()
  let { visible, setVisible, contractWith } = props
  const [contract, setContract] = useState({})
  let [allCountry, setAllCountry] = useState([])
  let [countryUniversity, setCountryUniversity] = useState([])
  let [contractFile, setContractFile] = useState({})
  let [mediaKey, setMediaKey] = useState(moment())
  let [oldContract, setOldContract] = useState({})
  let [agentId, setAgentId] = useState('')
  let [contractBackup, setContractBackup] = useState('')
  let [oldContractBackup, setOldContractBackup] = useState('')

  const chooseFiles = (files, name) => {
    if (name == 'oldContract') {
      setOldContract(files)
    } else {
      setContractFile(files)
    }
  }

  const {
    form: { getFieldDecorator, setFieldsValue, getFieldValue, resetFields },
    events,
    id,
    universityTypeList
  } = props
  const appEvents = {
    loadCountry: async () => {
      let filters = {
        sortField: 'countryName', sortOrder: 'ascend',
        results: 100,
        count: 100
      }
      let { data } = await dispatch(listAllCountries(filters))
      setAllCountry(data)
    },
    loadUniversity: async (item) => {
      let obj = {
        results: 1000000,
        universityCountry: item,
        sortField: 'universityName',
        sortOrder: 'ascend'
      }
      let data = await dispatch(listQuickSearchUniversities(obj))
      setCountryUniversity(data)
    }
  }

  useEffect(() => {
    appEvents.loadCountry()
  }, [])

  let inputTypes = {
    fields: [
      {
        key: 'contractWith',
        label: 'Contract With',
        required: true,
        type: 'select',
        showSearch: true,
        options: contractWith,
        keyAccessor: x => x.name,
        valueAccessor: x => `${x.name}`,
        onChange: x => setFieldsValue({ contractWith: x })
      },
      {
        key: 'countryId',
        label: 'Country',
        required: true,
        type: 'select',
        showSearch: true,
        options: allCountry,
        keyAccessor: x => x._id,
        valueAccessor: x => `${x.countryName}`,
        onChange: x => {
          setFieldsValue({ countryId: x, universityId: undefined })
          appEvents.loadUniversity(x)
        }
      },
      {
        key: 'institutionType',
        label: 'Institution Type',
        required: true,
        type: 'select',
        showSearch: true,
        options: instituteType,
        keyAccessor: x => x,
        valueAccessor: x => `${x}`,
        onChange: x => {
          setFieldsValue({
            institutionType: x,
            universityType: ''
          })
        }
      },
      {
        key: 'universityType',
        label: `${getFieldValue('institutionType')} Type`,
        placeholder: `Select ${getFieldValue('institutionType')} Type`,
        required: true,
        type: 'select',
        showSearch: true,
        hidden: (getFieldValue('institutionType') == 'Pathways'),
        options: universityTypeList,
        keyAccessor: x => x.value,
        valueAccessor: x => `${x.name}`,
        onChange: x => setFieldsValue({ universityType: x, universityId: undefined, universityName: undefined })
      },
      {
        key: 'universityId',
        label: getFieldValue('institutionType'),
        placeholder: `Enter ${getFieldValue('institutionType')}`,
        required: true,
        type: 'select',
        hidden: !(getFieldValue('universityType') && getFieldValue('universityType') === 'alreadyAdded') || (getFieldValue('institutionType') == 'Pathways'),
        showSearch: true,
        options: countryUniversity,
        keyAccessor: x => x._id,
        valueAccessor: x => `${x.universityName}`,
        onChange: x => setFieldsValue({ universityId: x })
      },
      {
        key: 'universityName',
        label: getFieldValue('institutionType'),
        placeholder: `Enter ${getFieldValue('institutionType')}`,
        required: true,
        hidden: !(getFieldValue('universityType') && getFieldValue('universityType') === 'other')
      },
      {
        key: 'originalStartDate',
        label: 'Original Start Date',
        type: 'date',
        required: true,
        onChange: x => setFieldsValue({ originalStartDate: x })
      },
      {
        key: 'startDate',
        label: 'Start Date',
        type: 'date',
        required: true,
        onChange: x => setFieldsValue({ startDate: x })
      },
      {
        key: 'endDate',
        label: 'End Date',
        type: 'date',
        required: true,
        onChange: x => setFieldsValue({ endDate: x })
      },
      {
        label: 'Old Contract',
        customField: (
          <InputBox title={'Old Contract'} className={'rowFlex'} customStyle={{ marginTop: 10 }}>
            <Input
              type={'file'}
              name={'oldContract'}
              id={'oldContract'}
              key={mediaKey}
              className={'form-control'}
              onChange={(e) => chooseFiles(e.target.files[0] || null, 'oldContract')}
            />
            <DownloadLink file={{ url: oldContractBackup }} />
          </InputBox>
        )
      },
      {
        label: 'Contract',
        customField: (
          <InputBox title={'* Contract'} className={'rowFlex'} customStyle={{ marginTop: 10 }}>
            <Input
              type={'file'}
              name={'contract'}
              id={'contract'}
              key={mediaKey}
              className={'form-control'}
              onChange={(e) => chooseFiles(e.target.files[0] || null, 'contract')}
            />
            <DownloadLink file={{ url: contractBackup }} />
          </InputBox>
        )
      },
      {
        key: 'contractType',
        label: 'Contract Type',
        required: true,
        type: 'select',
        showSearch: true,
        options: ['Direct', 'Third Party', 'Exclusive', 'Other'],
        keyAccessor: x => x,
        valueAccessor: x => x,
        onChange: x => setFieldsValue({ contractType: x })
      },
      {
        key: 'representativeName',
        label: 'Representative Name',
        required: true
      },
      {
        key: 'repContactNumber',
        label: 'Rep. Contact Number',
        required: true,
      },
      {
        key: 'repEmailId',
        label: 'Rep. Email ID',
        required: true,
        type: 'email'
      },
      {
        key: 'registeredNumber',
        label: 'Registered Number'
      },
      {
        key: 'registeredEmailId',
        label: 'Registered Email ID'
      },
      {
        key: 'additionalContactName',
        label: 'Additional Contact Name'
      },
      {
        key: 'additionalContactNumber',
        label: 'Additional Contact Number'
      },
      {
        key: 'additionalContactEmail',
        label: 'Additional Contact Email',
        type: 'email'
      },
      {
        key: 'commissionStructure',
        label: 'Commission Structure',
        required: true,
        type: 'select',
        showSearch: true,
        options: ['Slab %', 'Fixed', 'Other'],
        keyAccessor: x => x,
        valueAccessor: x => x,
        onChange: x => setFieldsValue({ commissionStructure: x })
      },
      {
        key: 'commissionToUniz',
        label: 'Commission - Uniz',
        required: true,
        type: 'number'
      },
      {
        key: 'commissionToPartners',
        label: 'Commission - To Partners',
        required: true,
        type: 'number'
      },
      {
        key: 'currency',
        label: 'Currency',
        required: true,
        type: 'select',
        showSearch: true,
        options: Object.keys(countryCurrencyObject).map(code => ({
          code,
          country: countryCurrencyObject[code]
        })),
        keyAccessor: x => x.code,
        valueAccessor: x => `${x.code} - ${x.country}`,
        onChange: x => setFieldsValue({ currency: x })
      },
      {
        key: 'totalTarget',
        label: 'Total Target',
        type: 'text'
      },
      {
        key: 'uniwiseTarget',
        label: 'UniWise Target',
        type: 'text'
      },
      {
        key: 'minEnrolments',
        label: 'Min Enrolments',
        type: 'text'
      },
      {
        key: 'northIndia',
        label: 'North India',
        type: 'text'
      },
      {
        key: 'restOfIndia',
        label: 'Rest Of India',
        type: 'text'
      },
      {
        key: 'international',
        label: 'International',
        type: 'text'
      },
      {
        key: 'targetVsAchieved',
        label: 'Target vs Achived',
        type: 'text'
      },
      {
        key: 'trainingStatus',
        label: 'Training Status',
        required: true
      },
      {
        key: 'trainingDate',
        label: 'Training Date',
        type: 'date'
      },
      {
        key: 'applicableRegions',
        label: 'Applicable Regions',
        type: 'text'
      },
      {
        key: 'programLevel',
        label: 'Program Level',
        showSearch: true,
        type: 'select',
        mode: 'multiple',
        options: ProgramLevel,
        keyAccessor: x => x,
        valueAccessor: x => x,
        onChange: programLevel => setFieldsValue({ programLevel })
      },
      {
        key: 'intake',
        label: 'Intake',
        type: 'select',
        showSearch: true,
        mode: 'multiple',
        options: Intakes,
        keyAccessor: x => x,
        valueAccessor: x => x,
        onChange: intakes => setFieldsValue({ intake:intakes })
      },

      {
        key: 'under18',
        label: 'Under 18 ',
        required: true,
        type: 'select',
        showSearch: true,
        options: ['Yes', 'No', 'To Be Confirmed'],
        keyAccessor: x => x,
        valueAccessor: x => x,
        onChange: x => setFieldsValue({ under18: x })
      },
      {
        key: 'changeOfAgent',
        label: 'Change of Agent',
        required: true,
        type: 'select',
        showSearch: true,
        options: ['Yes', 'No', 'To Be Confirmed'],
        keyAccessor: x => x,
        valueAccessor: x => x,
        onChange: x => setFieldsValue({ changeOfAgent: x })
      },
      /*{
        label: 'Change of Agent',
        customField: (
          <InputBox title={'Change of Agent'} className={'rowFlex'} customStyle={{ marginTop: 10 }}>
            <AgentTypeheadComponent
              key={agentId}
              agentId={agentId}
              dispatch={dispatch}
              customStyle=''
              onSelect={item => setAgentId(item)}
              blockStatus={false}
            />
          </InputBox>
        )
      },*/
      {
        key: 'campus',
        label: 'Campus',
        required: false
      },
      {
        key: 'details',
        label: 'Notes',
        type: 'textarea',
        span: 24
      }
    ]
  }


  const formItemLayout = {
    labelCol: {
      xs: { span: 0 },
      sm: { span: 0 },
      md: { span: 0 }
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 24 },
      md: { span: 24 }
    }
  }

  const getSingleContract = async () => {
    if (id) {
      let data = await dispatch(getSingleContractFxn({ contractId: id }))
      if (data) {
        setContract(data.data)
      }
    }
  }

  useEffect(() => {
    getSingleContract()
  }, [])

  const handleSubmit = async (e) => {
    const { form } = props
    e.preventDefault()
    form.validateFieldsAndScroll(async (err, valData) => {
      if (!err) {
        valData.contractId = id
        console.log(valData, "vvvvvvvvvvvvvvvvvvvvvvvvvv")
        let fd = new FormData()
        fd.append('obj', JSON.stringify(valData))
        if (contractFile && contractFile.name) {
          fd.append('contract', contractFile, contractFile.name)
        }
        if (oldContract && oldContract.name) {
          fd.append('oldContract', oldContract, oldContract.name)
        }

        let resp = await dispatch(updateContract(fd))
        if (resp && !resp.error) {

          events.hideEditDrawer()
          setMediaKey(moment())
        }
      } else {
        notification.warning({
          message: 'Fill All Required Fields'
        })
      }
    })
  }

  useEffect(() => {
    appEvents.loadUniversity(contract.countryId)
    props.form.setFieldsValue({
      contractWith: `${contract.contractWith || ''}`,
      countryId: `${contract.countryId || ''}`,
      universityType: contract.universityType || '',
      institutionType: contract.institutionType || 'University',
      universityId: contract.universityId || '',
      universityName: `${contract.universityName || ''}`,
      originalStartDate: contract.originalStartDate ? moment(contract.originalStartDate) : null,
      startDate: contract.startDate ? moment(contract.startDate) : null,
      endDate: contract.endDate ? moment(contract.endDate) : null,
      contractType: contract.contractType || '',
      representativeName: `${contract.representativeName || ''}`,
      repContactNumber: `${contract.repContactNumber || ''}`,
      repEmailId: `${contract.repEmailId || ''}`,
      registeredNumber: `${contract.registeredNumber || ''}`,
      registeredEmailId: `${contract.registeredEmailId || ''}`,
      agentId: `${contract.agentId || ''}`,
      additionalContactName: `${contract.additionalContactName || ''}`,
      additionalContactNumber: `${contract.additionalContactNumber || ''}`,
      additionalContactEmail: `${contract.additionalContactEmail || ''}`,
      commissionStructure: contract.commissionStructure || '',
      commissionToUniz: contract.commissionToUniz || null,
      commissionToPartners: contract.commissionToPartners || null,
      totalTarget: contract.totalTarget || null,
      uniwiseTarget: contract.uniwiseTarget || null,
      minEnrolments: contract.minEnrolments || null,
      northIndia: contract.northIndia || null,
      restOfIndia: contract.restOfIndia || null,
      international: contract.international || null,
      targetVsAchieved: contract.targetVsAchieved || null,
      trainingStatus: `${contract.trainingStatus || ''}`,
      trainingDate: contract.trainingDate ? moment(contract.trainingDate) : null,
      applicableRegions: contract.applicableRegions || '',
      programLevel: contract.programLevel || [],
      intake: contract.intake || [],
      under18: contract.under18 || '',
      campus: `${contract.campus || ''}`,
      details: `${contract.details || ''}`,
      currency: `${contract.currency || ''}`,
      changeOfAgent: contract.changeOfAgent || ''
    })

    if (contract.agentId) {
      setAgentId(contract.agentId)
    }

    setTimeout(() => {
      props.form.setFieldsValue({
        universityId: `${contract.universityId || ''}`,
        universityName: contract.universityName
      })
    }, 500)
    if (contract.contract && contract.contract.path) {
      setContractBackup(contract.contract.path)
    }
    if (contract.oldContract && contract.oldContract.path) {
      setOldContractBackup(contract.oldContract.path)
    }
  }, [contract])


  return <div>
    <Drawer
      visible={visible}
      width={'85%'}
      placement='right'
      onClose={events.hideEditDrawer}
      title={'Edit Contract'}>
      <div className='form-box'>
        <div className='card unizportal'>
          <Form onSubmit={handleSubmit}>
            <Row gutter={16} className={'wrapBox'}>
              {inputTypes.fields.map((item, key) => {
                return (
                  <React.Fragment key={key}>
                    {item.customField ?
                      <Col span={item.span ? item.span : 6}>
                        {item.customField}
                      </Col>
                      :
                      !item.hidden && <Col span={item.span ? item.span : 6} key={key}>
                        <GetEachFormFields
                          item={item}
                          getFieldDecorator={getFieldDecorator}
                          formItemLayout={formItemLayout} />
                      </Col>}
                  </React.Fragment>
                )
              })}
            </Row>
            <Form.Item style={{ marginTop: 25 }}>
              <Button type='primary' htmlType='submit' className={'btn'}>
                Update
              </Button>
            </Form.Item>
          </Form>
        </div>
      </div>
    </Drawer>
  </div>
}

const EditContract = Form.create()(Edit)
export default EditContract
